module.exports = __webpack_public_path__ + "img/farming_41.ab5a002a.png";